import store from '@/store';

const GLOBAL_HEADERS = {};
const RESPONSE_HANDLERS = {};

// function objectToQueryString(obj) {
//   return Object.keys(obj).map(key => `${key}=${obj[key]}`).join('&');
// }

export function setGlobalRequestHeader(header, value = undefined) {
  GLOBAL_HEADERS[header] = value;
}

export function addResponseHandler(status, handler) {
  if (!RESPONSE_HANDLERS[status]) {
    RESPONSE_HANDLERS[status] = [];
  }
  RESPONSE_HANDLERS[status].push(handler);
}

export function removeResponseHandler(status, handler) {
  if (RESPONSE_HANDLERS[status]) {
    const idx = RESPONSE_HANDLERS[status].indexOf(handler);
    if (idx > -1) {
      RESPONSE_HANDLERS[status].splice(idx, 1);
    }
  }
}

function syncAuthHeader() {
  const token = store.state.userData
    ? (store.state.userData.drf_token || store.state.userData.token)
    : undefined;
  if (token) {
    setGlobalRequestHeader('Authorization', `Token ${token}`);
  } else {
    setGlobalRequestHeader('Authorization', undefined);
  }
}

syncAuthHeader();
store.watch(state => (state.userData ? (state.userData.drf_token || state.userData.token) : undefined), syncAuthHeader);

export default async function api({
  url,
  method = 'GET',
  body = null,
  json = null,
  params = null,
  headers = {},
  options = {},
} = {}) {
  const init = {
    method,
    headers,
  };

  // add global headers if not assigned to something else
  // eslint-disable-next-line array-callback-return
  Object.keys(GLOBAL_HEADERS).filter(key => !headers[key]).map((key) => {
    init.headers[key] = GLOBAL_HEADERS[key];
  });

  // default to application json if content type not set and using json
  if (json && !init.headers['Content-Type'] && method !== 'GET') {
    init.headers['Content-Type'] = 'application/json';
  }

  if (body !== null) {
    init.body = body;
  } else if (json !== null) {
    init.body = JSON.stringify(json);
  }

  // eslint-disable-next-line array-callback-return
  Object.keys(options).filter(key => !init[key]).map((key) => {
    init[key] = options[key];
  });

  let urlToFetch;

  if (!url.startsWith('http:') && !url.startsWith('https:')) {
    urlToFetch = `${process.env.VUE_APP_API_URL}${url}`;
  } else {
    urlToFetch = url;
  }

  if (params) {
    const query = new URLSearchParams(params).toString();
    if (query) {
      urlToFetch += `?${query}`;
    }
  }

  let response;

  try {
    response = await fetch(urlToFetch, init);
  } catch (e) {
    return {
      error: e,
      status: 0,
      ok: false,
    };
  }

  let responseBody;

  const contentType = response.headers.get('content-type');

  if (contentType && contentType.indexOf('application/json') !== -1) {
    responseBody = await response.json();
  } else {
    responseBody = await response.text();
  }

  if (RESPONSE_HANDLERS[response.status]) {
    RESPONSE_HANDLERS[response.status].forEach(
      handler => handler(response, responseBody),
    );
  }

  return {
    status: response.status,
    body: responseBody,
    ok: response.status >= 200 && response.status < 300,
  };
}
